import { PermissionArrayType } from '../../../types/other';
import { PERMISSIONROLECONSTANTS } from '../../../features/utils/utils.action';

export const serviceTypePermissions: PermissionArrayType = {
  CREATE: [PERMISSIONROLECONSTANTS.superadmin],
  READ: [PERMISSIONROLECONSTANTS.superadmin],
  UPDATE: [PERMISSIONROLECONSTANTS.superadmin],
  DELETE: [PERMISSIONROLECONSTANTS.superadmin],
};
